import './DailyPage.css'
import React, {useContext, useEffect, useState} from "react";
import {ThemeContext} from "../../../../providers/themeContext/theme-context.tsx";
import {useUserContext} from "../../../../providers/userProvider/user-context.tsx";
import LeaderBoardUpdatingPage from "../updatingPage/leaderBoardUpdatingPage.tsx";
import useLoading from "../../../../providers/loadingContext/useLoading.ts";
import {formatTime} from "../../../../common/utils/date-format.ts";
import {VISITOR_LOGIN_LEADERBOARD_TIP} from "../../../../common/constants.ts";
import {GAEvents} from "../../../../common/utils/GA4/GAEvents.ts";
import {apiService} from "../../../../common/utils/http/api-service.ts";
import debounce from 'lodash/debounce';
import {IDailyGameCorrectWord, IDailyGameRankingData, LoginType} from "../../../../common/utils/http/IResponse.ts";
import CustomAvatar from "../../../../components/CustomAvatar/CustomAvatar.tsx";
import Avatar from "../../../../components/Avatar/Avatar.tsx";

type props = {
    isOpen: boolean,
    countryRankingIndex: number,
    openOpponentUserInfoPage: (userId: string) => void
}

// 每日排行榜
const DailyRanking: React.FC<props> = ({isOpen, countryRankingIndex, openOpponentUserInfoPage}) => {
    const {showLoading, hideLoading} = useLoading();
    // 主题管理器
    const {imgUrls} = useContext(ThemeContext);
    const {user} = useUserContext();
    // 正确的单词
    const [word, setWord] = useState<IDailyGameCorrectWord | null>(null)
    // 排行
    const [rankResult, setRankResult] = useState<IDailyGameRankingData>({
        dailyRanks: [],
        wordIssue: 0,
        myRank: '',
        playTime: 0
    });

    useEffect(() => {
        if (isOpen) {
            GAEvents.leaderboardPageShow('Daily')
            loadDailyCorrectWord();
            getDailyRankList();
        }
    }, [isOpen, countryRankingIndex]);

    // 获取单词信息，用来那里面那个issue，设置day几
    // 获取每日游戏正确单词
    const loadDailyCorrectWord = debounce(async () => {
        try {
            showLoading()
            const response = await apiService.getDailyGameWords()
            if (response.code === 200) {
                setWord(() => response.data)
            }
        } catch (error) {
            console.log(error)
            setWord(null)
        } finally {
            hideLoading()
        }
    }, 100)

    // 获取rank列表
    const getDailyRankList = debounce(async () => {
        try {
            showLoading()
            const response = await apiService.getDailyGameRank(countryRankingIndex === 1 ? "" : user?.countryCode)
            if (response.code === 200) {
                setRankResult(response.data);
            }
        } finally {
            hideLoading()
        }
    }, 100)

    return (
        rankResult?.dailyRanks.length >= 4 ?
            <div className="daily-ranking-page">
                {/*前三名展示*/}
                <div className="ranking-top-tree-container ">
                    {/*第二名*/}
                    <div className="every-item-container second-item-position game-slide-up-animation-20">
                        {/*头像*/}
                        {/*<img className="second-avatar"*/}
                        {/*     src={rankResult?.dailyRanks[1]?.cgtnAvatar ?? imgUrls.defaultAvatarUrl}*/}
                        {/*     alt="avatar"/>*/}
                        <CustomAvatar onClick={() => openOpponentUserInfoPage(rankResult?.dailyRanks[1]?.userId ?? "")}
                                      className="height-50 width-50 margin-bottom-3"
                                      avatar={rankResult?.dailyRanks[1]?.cgtnAvatar ?? imgUrls.defaultAvatarUrl}
                                      avatarFrame={rankResult?.dailyRanks[1]?.avatarFrame}/>
                        {/*昵称*/}
                        <span
                            className="nickname text-center font-size-11 my-roboto-regular">{rankResult?.dailyRanks[1]?.cgtnName ?? "Jack"} </span>
                        {/*分数*/}
                        <span
                            className="color-blue my-roboto-bold font-size-11">{formatTime(rankResult?.dailyRanks[1]?.playedTime ?? 0)}</span>
                    </div>
                    {/*第一名*/}
                    <div className="every-item-container first-item-position game-slide-up-animation-20">
                        {/*头像*/}
                        {/*<img className="first-avatar"*/}
                        {/*     src={rankResult?.dailyRanks[0]?.cgtnAvatar ?? imgUrls.defaultAvatarUrl}*/}
                        {/*     alt="avatar"/>*/}
                        <CustomAvatar onClick={() => openOpponentUserInfoPage(rankResult?.dailyRanks[0]?.userId ?? "")}
                            className="height-50 width-50 margin-bottom-3"
                                      avatar={rankResult?.dailyRanks[0]?.cgtnAvatar ?? imgUrls.defaultAvatarUrl}
                                      avatarFrame={rankResult?.dailyRanks[0]?.avatarFrame}/>
                        {/*昵称*/}
                        <span
                            className="nickname text-center font-size-11 my-roboto-regular">{rankResult?.dailyRanks[0]?.cgtnName ?? "Neal"}</span>
                        {/*分数*/}
                        <span
                            className="font-size-11 color-blue my-roboto-bold">{formatTime(rankResult?.dailyRanks[0]?.playedTime ?? 0)}</span>
                    </div>
                    {/*第三名*/}
                    <div className="every-item-container third-item-position game-slide-up-animation-20">
                        {/*头像*/}
                        {/*<img className="third-avatar"*/}
                        {/*     src={rankResult?.dailyRanks[2]?.cgtnAvatar ?? imgUrls.defaultAvatarUrl}*/}
                        {/*     alt="avatar"/>*/}
                        <CustomAvatar onClick={() => openOpponentUserInfoPage(rankResult?.dailyRanks[2]?.userId ?? "")}
                            className="height-50 width-50 margin-bottom-3"
                                      avatar={rankResult?.dailyRanks[2]?.cgtnAvatar ?? imgUrls.defaultAvatarUrl}
                                      avatarFrame={rankResult?.dailyRanks[2]?.avatarFrame}/>
                        {/*昵称*/}
                        <span
                            className="nickname text-center font-size-11  my-roboto-regular">{rankResult?.dailyRanks[2]?.cgtnName ?? "Ben"}</span>
                        {/*分数*/}
                        <span
                            className="font-size-11 color-blue my-roboto-bold">{formatTime(rankResult?.dailyRanks[2]?.playedTime ?? 0)}</span>
                        {/*勋章*/}
                    </div>
                    {/*勋章*/}
                    <div className="leaderboard-icon-row">
                        <img className={`rank-pic-second ${isOpen ? "slide-up-second" : ""}`}
                             src={imgUrls.rankSecondPicUrl}
                             alt="img"/>
                        <img className={`rank-pic-third ${isOpen ? "slide-up-third" : ""}`}
                             src={imgUrls.rankThirdPicUrl}
                             alt="img"/>
                        <img className={`rank-pic-first ${isOpen ? "slide-up-first" : ""}`}
                             src={imgUrls.rankFirstPicUrl}
                             alt="img"/>
                    </div>
                </div>
                {/*后面排名列表*/}
                <div style={{backgroundImage: `url(${imgUrls.leaderboardListBgUrl})`}}
                     className="width-273 height-240 position-bottom-43 margin-left-right-auto border-radius-10 rank-list margin-top-6 display-flex-column position-absolute">
                    <div
                        className="my-roboto-medium margin-top-6 padding-top-6 padding-bottom-6 rank-title-border">Day {word?.wordIssue}</div>
                    <div className="height-210 margin-top-6 overflow-y-auto display-flex-column">
                        {rankResult?.dailyRanks.map((item, index) => {
                            if (index > 2) {
                                return <div key={item.cgtnName ?? "" + index} className="list-item">
                                    <div className="my-roboto-bold">{index + 1}</div>
                                    {/*<img className="item-avatar"*/}
                                    {/*     src={item?.cgtnAvatar ?? imgUrls.defaultAvatarUrl}*/}
                                    {/*     alt="avatar"/>*/}
                                    <CustomAvatar onClick={() => openOpponentUserInfoPage(item.userId ?? "")}
                                        className="height-26 width-26"
                                                  avatar={item?.cgtnAvatar ?? imgUrls.defaultAvatarUrl}
                                                  avatarFrame={item?.avatarFrame}/>
                                    <div
                                        className="my-roboto-regular text-ellipsis text-left">{item.cgtnName}</div>
                                    <div
                                        className="my-roboto-bold color-blue">{formatTime(item.playedTime ?? 0)}</div>
                                </div>
                            }
                        })}
                    </div>
                    {/*<div className="list-item">*/}
                    {/*    <div className="my-roboto-regular item-margin">5</div>*/}
                    {/*    <img className="item-avatar item-margin" src={imgUrls.tempProfileAvatar5}*/}
                    {/*         alt="avatar"/>*/}
                    {/*    <div className="my-roboto-regular item-margin">Cecitia Dixon</div>*/}
                    {/*    <div className="my-roboto-regular item-margin color-blue">20:28</div>*/}
                    {/*</div>*/}
                    {/*<div className="list-item">*/}
                    {/*    <div className="my-roboto-regular item-margin">6</div>*/}
                    {/*    <img className="item-avatar item-margin" src={imgUrls.tempProfileAvatar5}*/}
                    {/*         alt="avatar"/>*/}
                    {/*    <div className="my-roboto-regular item-margin">Cecitia Dixon</div>*/}
                    {/*    <div className="my-roboto-regular item-margin color-blue">12:00</div>*/}
                    {/*</div>*/}
                    {/*<div className="list-item">*/}
                    {/*    <div className="my-roboto-regular item-margin">7</div>*/}
                    {/*    <img className="item-avatar item-margin" src={imgUrls.tempProfileAvatar5}*/}
                    {/*         alt="avatar"/>*/}
                    {/*    <div className="my-roboto-regular item-margin">Cecitia Dixon</div>*/}
                    {/*    <div className="my-roboto-regular item-margin color-blue">12:00</div>*/}
                    {/*</div>*/}
                    {/*<div className="list-item">*/}
                    {/*    <div className="my-roboto-regular item-margin">8</div>*/}
                    {/*    <img className="item-avatar item-margin" src={imgUrls.tempProfileAvatar5}*/}
                    {/*         alt="avatar"/>*/}
                    {/*    <div className="my-roboto-regular item-margin">Cecitia Dixon</div>*/}
                    {/*    <div className="my-roboto-regular item-margin color-blue">12:00</div>*/}
                    {/*</div>*/}
                </div>
                {/*底部自己的排行信息*/}
                {user?.loginType === LoginType.CGTN ?
                    <div className="self-container bg-color-blue">
                        <div className="my-roboto-medium item-margin color-white">{rankResult?.myRank ?? "200+"}</div>
                        {/*<img className="item-avatar-self item-margin"*/}
                        {/*     src={user.cgtnAvatar ?? imgUrls.defaultAvatarUrl}*/}
                        {/*     alt="avatar"/>*/}
                        <Avatar className="width-26 height-26"/>
                        <div
                            className="my-roboto-regular item-margin text-ellipsis color-white">{user?.cgtnName ?? user?.guestName}</div>
                        <div
                            className="my-roboto-medium item-margin color-white">{formatTime(rankResult?.playTime ?? 0)}</div>
                    </div> :
                    <div className="self-container-guest bg-color-blue font-size-16 my-roboto-medium color-white">
                        {VISITOR_LOGIN_LEADERBOARD_TIP}
                    </div>
                }
            </div>
            : <LeaderBoardUpdatingPage onRefresh={getDailyRankList}/>
    )
}

export default DailyRanking